export default function AuthConfirmationPanel({
  signupConfirmationEmail,
  passwordResetEmail,
  passwordResetComplete,
  onModeChange,
}) {
  const isSignup = Boolean(signupConfirmationEmail);
  const title =
    signupConfirmationEmail || passwordResetEmail
      ? "Verifique seu email"
      : "Senha atualizada";

  return (
    <div
      className={`panel auth-login-form auth-login-form--${
        isSignup ? "signup" : "signin"
      } auth-confirmation-panel`}
    >
      <h1 className="auth-login-form__title">
        {title}
      </h1>
      {signupConfirmationEmail && (
        <>
          <p className="auth-confirmation-panel__text">
            Cadastro criado com sucesso. Enviamos um link de confirmacao para{" "}
            <strong>{signupConfirmationEmail}</strong>.
          </p>
          <p className="auth-confirmation-panel__hint">
            Depois de confirmar sua conta pelo email, volte aqui para entrar.
          </p>
        </>
      )}
      {passwordResetEmail && (
        <>
          <p className="auth-confirmation-panel__text">
            Enviamos um link de recuperacao para{" "}
            <strong>{passwordResetEmail}</strong>.
          </p>
          <p className="auth-confirmation-panel__hint">
            Abra o email e siga o link para cadastrar uma nova senha.
          </p>
        </>
      )}
      {passwordResetComplete && (
        <>
          <p className="auth-confirmation-panel__text">
            Sua senha foi atualizada com sucesso.
          </p>
          <p className="auth-confirmation-panel__hint">
            Entre novamente usando sua nova senha.
          </p>
        </>
      )}
      <button
        className="btn-red"
        type="button"
        onClick={() => onModeChange("signin")}
      >
        Voltar para entrar
      </button>
    </div>
  );
}
